(function($) {
  /* ==== CONFERENCE ==== */

  /**
   * Filter Members
   */
  $('#conference-form').submit(function(event) {
    event.preventDefault();
    conferenceID = $('#conference-id').val();

    $.ajax({
      url: ajax_object.ajaxurl,
      type: 'POST',
      data: {
        action: 'ajax_action_conference_registration',
        conferenceID: conferenceID,
      },
      success: function(response) {
        response = $.parseJSON(response);
        $('#conference-form input[type="submit"]').prop('disabled', true);
        $('#conference-form-reponse').append(response.message);
      },
      error: function(response) {
        response = $.parseJSON(response);
        $('#conference-form-reponse').append(response.message);
        return false;
      },
    });
  });
})(jQuery);
